export class AdditionalView {
  id: number;
  text: string;
  title: string;
  isInput: boolean;
  isFilter: boolean;
  isShownOnComparison: boolean;
  inputMinimum: number;
  constructor(values: any) {
    Object.assign(this, values);
  }
}
